import { withTranslation } from "react-i18next"
import { connect } from "react-redux";
import { 
  Divider, 
  // Table, Image, Space, Button 
} from "antd";
import { push } from "connected-react-router";
import styled from "styled-components";
import { useState } from "react";

// Components
import Title from "components/Title";
// import Text from "components/Text";
import CustomMountModal from "components/CustomMountModal";

// Redux
import { setCurrentHomeView, setGlobalPaymentData, setQuotationBasket, setGlobalSelectedMount } from 'modules/ui/actions'

// Utils
// import { post, } from "library/endpoints";

// Styled
const ImageWrapper = styled.div`
  text-align: center;
  background: black;
  height: 140px;
  margin: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 0 5px grey;
  border-radius: 10px;
  position: relative;
  cursor: pointer;

  > image {
    width: 90%;
  }
`;

/**
 * QuotationBasket
 * @param {*} props 
 * @returns 
 */
const QuotationBasket = (props) => {
  const [displayModal, setDisplayModal] = useState(false);
  const [selectedMount, setSelectedMount] = useState(null);

  const handleOnSelectQuotation = (quotation) => {
    props.setGlobalPaymentData(quotation);
    props.setGlobalSelectedMount(quotation);
    props.setCurrentHomeView('quotation_payment');
    props.push('/configurator');
  }

  // const handleOnRefuseQuotation = async (record) => {
  //   try {
  //     const response = await post(`/frontend/basket/refuse/${record._id}`);
  //     console.log(response.data)
  //     props.setQuotationBasket(response.data);
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }


  const handleOnDownload = (url) => {
    window.open(url);
  }
  
  // const handleOnSelectMount = (mount) => {
  //   props.setGlobalSelectedMount(mount);
  //   props.push(`/configurator`)
  // }


  // const columns = [
  //   {
  //     title: 'Montage',
  //     dataIndex: 'mount',
  //     key: 'mount',
  //     render: (text, record) => <><Image src={`${process.env.REACT_APP_S3_FILES_URL}${record.products[0].mount.output}`} width={100} /></>,
  //   },
  //   {
  //     title: 'Support',
  //     dataIndex: 'support',
  //     key: 'support',
  //     render: (text, record) => <><Text size={14}>{`${record.products[0].support.parentSupport._provider_name} : ${record.products[0].support.name}`}</Text></>,
  //   },
  //   {
  //     title: 'Montant',
  //     dataIndex: 'initial_amount',
  //     key: 'initial_amount',
  //     render: (text, record) => <><Text size={14}>{record.initial_amount}€</Text></>,
  //   },

  //   {
  //     title: 'Ports',
  //     dataIndex: 'initial_amount',
  //     key: 'initial_amount',
  //     render: (text, record) => <><Text size={14}>{record.shipping_fees}€</Text></>,
  //   },

  //   {
  //     title: 'Total',
  //     dataIndex: 'initial_amount',
  //     key: 'initial_amount',
  //     render: (text, record) => <><Text size={14}>{record.shipping_fees + record.initial_amount}€</Text></>,
  //   },

  //   {
  //     title: '',
  //     dataIndex: 'actions',
  //     key: 'actions',
  //     render: (text, record) => (
  //       <Space>
  //         <Button size="small" type="primary" onClick={() => handleOnSelectQuotation(record)}>Accepter</Button>
  //         <Button size="small" type="danger" onClick={() => handleOnRefuseQuotation(record)}>Refuser</Button>
  //       </Space>
  //     ),
  //   },
  // ];

  const dataSource = props.ui.quotationBasket.filter((entry) => entry.paid !== true).map((entry) => {
    return {
      ...entry,
      key: entry._d
    }
  })

  return (
    <div style={{ margin: 20}}>
      {
        displayModal && (
          <CustomMountModal 
            mount={selectedMount} 
            handleOnClose={() => setDisplayModal(false)}
            handleOnDownload={handleOnDownload}
            handleOnSelectMount={handleOnSelectQuotation}
          />
        )
      }

      <div>

        <Title size={18}>Vos montage personnalisés en attente</Title>
        <Divider />

        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>
          {
            dataSource.map((mount) => (
              <ImageWrapper>
                <img 
                  src={`${process.env.REACT_APP_S3_FILES_URL}${mount.products[0].mount.output}`} 
                  style={{ width: 125 }} 
                  onClick={() => { setSelectedMount(mount); setDisplayModal(true); }} alt={`Votre montage`}
                />
              </ImageWrapper>
            ))
          }
          </div>

        {/* <Table columns={columns} dataSource={dataSource} /> */}
      </div>
    </div>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

const dispatchToProps = {
  setCurrentHomeView,
  setGlobalPaymentData,
  push,
  setQuotationBasket,
  setGlobalSelectedMount
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(QuotationBasket));